import { useRef, useState } from 'react'
import { Building2, Menu } from 'lucide-react'
import { LANDING_PAGE_NAV_ITEMS, LANDING_PAGE_ROUTE, LANDING_PAGE_UI } from '@propbix/constants/public'
import { Button, ButtonLink } from '@/components/Button'
import { MobileNav } from '@/components/MobileNav'
import { ThemeToggle } from '@/components/ThemeToggle'
import { tenantAppHref } from '@/lib/tenant-app-url'

export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <a href="#main" className="skip-link">
        {LANDING_PAGE_UI.skipToContent}
      </a>

      <header className="sticky top-0 z-40 border-b border-line/10 bg-background/80 backdrop-blur-xl">
        <div className="page-shell flex items-center justify-between gap-4 py-3.5">
          <a href="#" className="flex min-w-0 items-center gap-3">
            <div className="flex size-9 shrink-0 items-center justify-center rounded-[var(--radius-control)] bg-brand text-white">
              <Building2 size={17} strokeWidth={1.75} />
            </div>
            <div className="min-w-0">
              <p className="truncate font-display text-base font-semibold tracking-tight text-ink">
                {LANDING_PAGE_UI.brandName}
              </p>
              <p className="hidden truncate text-xs text-muted sm:block">{LANDING_PAGE_UI.brandTagline}</p>
            </div>
          </a>

          <nav className="hidden items-center gap-7 text-sm font-medium text-muted lg:flex" aria-label="Primary">
            {LANDING_PAGE_NAV_ITEMS.map((item) => (
              <a key={item.href} href={item.href} className="transition-colors duration-200 hover:text-ink">
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            <div className="hidden sm:block">
              <ThemeToggle />
            </div>
            <ButtonLink
              variant="secondary"
              href={tenantAppHref(LANDING_PAGE_ROUTE.login)}
              className="hidden md:inline-flex"
            >
              {LANDING_PAGE_UI.loginCta}
            </ButtonLink>
            <ButtonLink variant="primary" href={tenantAppHref(LANDING_PAGE_ROUTE.signup)} className="hidden sm:inline-flex">
              {LANDING_PAGE_UI.navCta}
            </ButtonLink>
            <Button
              ref={menuButtonRef}
              variant="ghost"
              className="size-11 px-0 lg:hidden"
              aria-label={LANDING_PAGE_UI.openMenu}
              aria-expanded={menuOpen}
              aria-controls="landing-mobile-nav"
              onClick={() => setMenuOpen(true)}
            >
              <Menu size={20} strokeWidth={1.75} />
            </Button>
          </div>
        </div>
      </header>

      <div id="landing-mobile-nav">
        <MobileNav open={menuOpen} onClose={() => setMenuOpen(false)} menuButtonRef={menuButtonRef} />
      </div>
    </>
  )
}
